import { ApiQueryParams, apiRequest } from "../Api";
import { buildFilterParams, type FilterParam } from "@/hooks/apis/utils";

export interface GetPageElementsListRequest extends ApiQueryParams {
  page?: number;
  page_limit?: number;
  sort_by?: string;
  sort_order?: "asc" | "desc";
  search?: string;
  filters?: FilterParam[];
}

export interface PageElementsListResponse {
  success: boolean;
  message: string;
  data: unknown[];
  cached: boolean;
  total: number;
  page_items: number;
  last_page: number;
  current_page: number;
}

export const listPageElements = (params: GetPageElementsListRequest) => {
  const { filters, ...restParams } = params;
  const filterParams = buildFilterParams(filters);

  return apiRequest<void, PageElementsListResponse>({
    url: '/entities/list',
    scope: 'page_element',
    method: 'GET',
    params: { ...restParams, ...filterParams },
  });
};
